import { windowWidth } from './utils';

const stickySidebar = {
  wrap: document.getElementById('jsProdWrap') as HTMLElement,
  parent: document.querySelector('.product__wrap') as HTMLElement,

  init() {
    if (windowWidth > 1200) {
      this.setSticky();
    }
  },

  setSticky() {
    window.addEventListener('scroll', () => {
      const stickyRect = this.wrap.getBoundingClientRect();
      const containerRect = this.parent.getBoundingClientRect();

      if (stickyRect.bottom >= containerRect.bottom) {
        this.wrap.style.top = `150px`;
      }

      if (stickyRect.top <= containerRect.top) {
        this.wrap.style.top = `60px`;
      }
    });
  },
};

export default stickySidebar;
